// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jX9cj{position:absolute;inset:0;z-index:11;display:flex;align-items:center;justify-content:center}.u1O16{position:absolute;inset:0;background:rgba(0,0,0,.5);cursor:pointer}.r1DJE{position:relative;width:calc(100% - 128px);max-width:1100px;height:calc(100% - 128px);display:flex;z-index:1}.Ft6pc{background:var(--bg-standard, #f3f5ff) !important;color:var(--text-on-standard-bg, var(--text-standard, #282863));--text-standard: var(--text-on-standard-bg, var(--text-standard, #282863));--text-secondary: var(--text-on-standard-bg-secondary, var(--text-secondary, #696992));min-width:0 !important;min-height:0 !important}.x9Web{display:flex;justify-content:center;width:100%;text-align:center}.A3ZCA{width:100%;padding:16px 32px 32px}.R1c2U{width:100%;flex-shrink:0}.jBWyz{width:100%}.ddufT{animation:_W_YF 240ms ease-out}.pO8oV{animation:iHPQE 240ms ease-out}@keyframes _W_YF{from{margin-left:24px;opacity:0}to{margin-left:0;opacity:1}}@keyframes iHPQE{from{margin-left:-24px;opacity:0}to{margin-left:0;opacity:1}}.XBx7o{width:100%;flex:1 1 auto;min-height:0;display:flex;flex-direction:column}.cfnas{padding:0 16px 8px;display:flex;justify-content:center;text-align:center;flex-shrink:0}.kkl7G{flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;padding:0 16px 16px}.kkl7G .A3ZCA{padding:0}.DOEhn{flex-shrink:0;padding:12px 16px calc(12px + env(safe-area-inset-bottom));background:var(--bg-standard, #f3f5ff);position:sticky;bottom:0}.vszta{width:100%}.fp0Pr{flex:1 1 0;min-width:0}.uzyQS{border:2px solid var(--text-on-standard-bg, #282863) !important;background:transparent !important;color:var(--text-on-standard-bg, #282863) !important}.uzyQS:hover:not([disabled]):not(:active),.uzyQS:active{background:var(--text-on-standard-bg, #282863) !important;border-color:var(--text-on-standard-bg, #282863) !important;color:var(--bg-standard, #f3f5ff) !important}.UkYi8{background:var(--text-on-standard-bg, #282863) !important;border:2px solid var(--text-on-standard-bg, #282863) !important;color:var(--bg-standard, #f3f5ff) !important}.UkYi8:hover:not([disabled]):not(:active),.UkYi8:active{opacity:.85}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"overlay": `jX9cj`,
	"backdrop": `u1O16`,
	"modalWrapper": `r1DJE`,
	"modal": `Ft6pc`,
	"headerTitle": `x9Web`,
	"servicesList": `A3ZCA`,
	"dividerWrap": `R1c2U`,
	"slide": `jBWyz`,
	"slideForward": `ddufT`,
	"fadeInFromRight": `_W_YF`,
	"slideBack": `pO8oV`,
	"fadeInFromLeft": `iHPQE`,
	"bottomSheetContent": `XBx7o`,
	"bottomSheetTitle": `cfnas`,
	"bottomSheetBody": `kkl7G`,
	"bottomSheetFooter": `DOEhn`,
	"footerRowMobile": `vszta`,
	"footerButtonMobile": `fp0Pr`,
	"outlineButton": `uzyQS`,
	"primaryButton": `UkYi8`
};
export default ___CSS_LOADER_EXPORT___;
